define('controllers/mysetting/namechange/name-change-submit-success.ctrl',['app'], function (app) {
    app.controller('NameChangeSubmitSuccessCtrl', ['$q', '$scope', '$state', '$rootScope', 'UserInfoPreload',
        function ($q, $scope, $state, $rootScope, UserInfoPreload) {
            var Model = $scope.Model = {};
            var userTypePer = 1;
           if (UserInfoPreload.verifyBankState == 2) {
                Model.Tip = "开发者信息和商户服务信息提交成功，系统需要1-2个工作日进行审核，请耐心等待。";
            } else {
                Model.Tip = "开发者信息变更提交成功，系统需要1-2个工作日进行审核，请耐心等待。";
            }
            $scope.cancel = cancel;

            function cancel() {
                if ($rootScope.changeNameParams) {
                    delete $rootScope.changeNameParams;
                }
                $rootScope.toSettingUserInfo();
            }

        }]);
});
